import React from "react";
import { nextId } from "./idGenerator";

export interface RadioProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> {
  label?: React.ReactNode;
  className?: string;
}

function Radio({ label, className, id, ...rest }: RadioProps) {
  const [generatedId] = React.useState(() => nextId("ui-radio"));
  const fieldId = id || generatedId;

  const wrapperClasses = ["ui-radio", className].filter(Boolean).join(" ");

  return (
    <span className={wrapperClasses}>
      <input {...rest} type="radio" id={fieldId} className="ui-radio__input" />
      {label ? (
        <label className="ui-radio__label" htmlFor={fieldId}>
          {label}
        </label>
      ) : null}
    </span>
  );
}

export default Radio;
